function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#d53d53}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Travel_icon",
  transform: "translate(.001 -.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Subtraction_8",
  fill: "#fff",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.194 71.886l-6.434-.001c-.784-1.906-2.668-3.251-4.862-3.251s-4.079 1.346-4.862 3.251H31.46c-.784-1.906-2.668-3.251-4.862-3.251s-4.078 1.345-4.862 3.25H18.16c-.784-1.905-2.668-3.25-4.862-3.25s-4.078 1.345-4.862 3.25H2.001l-.002-.002L2 2 2.003 2h6.342c.72 2.033 2.669 3.493 4.954 3.493 2.286 0 4.235-1.46 4.955-3.492h3.39c.72 2.032 2.67 3.492 4.955 3.492S30.833 4.032 31.553 2h3.39c.72 2.032 2.67 3.492 4.955 3.492S44.132 4.032 44.852 2h6.344l.001.001v69.884h-.003z",
  transform: "rotate(45 26.12 63.065)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1b1464",
  d: "M33.844 69.885c1.299-1.957 3.528-3.251 6.054-3.251 2.526 0 4.754 1.293 6.053 3.25h3.246V4h-3.093c-1.271 2.091-3.578 3.492-6.206 3.492-2.628 0-4.935-1.4-6.206-3.492h-.887c-1.272 2.091-3.578 3.492-6.206 3.492-2.629 0-4.935-1.4-6.207-3.492h-.886c-1.272 2.091-3.578 3.492-6.207 3.492-2.628 0-4.934-1.4-6.206-3.492H4v65.885h3.246c1.299-1.958 3.527-3.251 6.053-3.251s4.755 1.293 6.053 3.25h1.193c1.299-1.957 3.527-3.25 6.054-3.25 2.526 0 4.754 1.294 6.053 3.251h1.192m2.803 4h-6.798v-.027c0-1.778-1.458-3.224-3.25-3.224-1.793 0-3.251 1.446-3.251 3.224v.027H16.55v-.027c0-1.778-1.458-3.224-3.25-3.224-1.793 0-3.251 1.446-3.251 3.224v.027h-8.05c-1.102 0-1.999-.898-1.999-2V2C0 .897.897 0 2 0h8.06c-.007.086-.011.175-.011.268 0 1.778 1.458 3.224 3.25 3.224 1.793 0 3.251-1.446 3.251-3.224 0-.088-.004-.179-.011-.268h6.82c-.007.086-.011.175-.011.268 0 1.778 1.458 3.224 3.25 3.224 1.793 0 3.251-1.446 3.251-3.224 0-.088-.003-.179-.01-.268h6.82c-.008.086-.012.175-.012.268 0 1.778 1.458 3.224 3.25 3.224 1.793 0 3.252-1.446 3.252-3.224 0-.088-.004-.179-.011-.268h8.058c1.104 0 2.001.897 2.001 2v69.885c0 1.102-.897 2-2 2h-8.048v-.027c0-1.778-1.459-3.224-3.251-3.224-1.793 0-3.25 1.446-3.25 3.224v.027z",
  transform: "rotate(45 26.12 63.065)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4505",
  transform: "rotate(-45 48.07 -43.755)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_323",
  cx: 3.202,
  cy: 3.202,
  r: 3.202,
  className: "cls-2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_324",
  cx: 3.202,
  cy: 3.202,
  r: 3.202,
  className: "cls-2",
  transform: "translate(0 13.046)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_325",
  cx: 3.202,
  cy: 3.202,
  r: 3.202,
  className: "cls-2",
  transform: "translate(0 26.092)"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3532",
  width: 26.102,
  height: 6.448,
  className: "cls-2",
  rx: 2,
  transform: "rotate(-45 99.062 -9.838)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3533",
  width: 26.102,
  height: 6.448,
  className: "cls-2",
  rx: 2,
  transform: "rotate(-45 83.927 -3.569)"
}));

var SvgHTravel = function SvgHTravel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.861,
    height: 89.861,
    viewBox: "0 0 89.861 89.861",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHTravel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-travel.e97ffdf1.svg";
export { ForwardRef as ReactComponent };